/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector, Type } from '@angular/core';
import { DialogInjector } from '@pacifico/components/modal-side/models/modal-lateral-injector';
import { DialogRef } from '@pacifico/components/modal-side/models/modal-ref';

export class ModalFunction<T> {
	dialogComponentRef!: ComponentRef<T>;

	constructor(
		protected componentFactoryResolver: ComponentFactoryResolver,
		protected appRef: ApplicationRef,
		protected injector: Injector,
		protected modalComponent: Type<T>,
		protected isModalLateral: boolean
	) {}

	appendDialogComponentToBody(): DialogRef {
		const map = new WeakMap();

		const dialogRef = new DialogRef();
		map.set(DialogRef, dialogRef);

		const sub = dialogRef.afterClosed.subscribe(() => {
			this.removeDialogComponentFromBody();
			sub.unsubscribe();
		});

		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.modalComponent);
		const componentRef = componentFactory.create(new DialogInjector(this.injector, map));
		this.appRef.attachView(componentRef.hostView);

		const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;
		document.body.appendChild(domElem);
		if (this.isModalLateral) {
			requestAnimationFrame(() => {
				domElem.firstElementChild?.classList.add('mostrar_detalle');
				domElem.lastElementChild?.classList.add('mostrar_detalle');
			});
		}

		this.dialogComponentRef = componentRef;
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		this.dialogComponentRef.instance.onClose.subscribe(() => {
			this.removeDialogComponentFromBody();
		});

		return dialogRef;
	}

	removeDialogComponentFromBody(): void {
		this.appRef.detachView(this.dialogComponentRef.hostView);
		this.dialogComponentRef.destroy();
	}

	forceClose(): void {
		this.dialogComponentRef?.destroy();
	}
}
